/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetUserMessageDetail200Response
 */
export interface GetUserMessageDetail200Response {
    /**
     * 
     * @type {number}
     * @memberof GetUserMessageDetail200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'readAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'displayStartAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'displayEndAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetUserMessageDetail200Response
     */
    'bodyStyle': GetUserMessageDetail200ResponseBodyStyleEnum;
}

export const GetUserMessageDetail200ResponseBodyStyleEnum = {
    md: 'MD',
    text: 'TEXT'
} as const;

export type GetUserMessageDetail200ResponseBodyStyleEnum = typeof GetUserMessageDetail200ResponseBodyStyleEnum[keyof typeof GetUserMessageDetail200ResponseBodyStyleEnum];


